<template>
  <b-modal
    id="modal-order-view"
    ref="modal"
    v-model="open"
    size="ov-custom"
    centered
    hide-footer
    title="VIEW ORDER DETAILS"
  >
    <b-overlay
      :show="modalLoading"
      blur="10px"
      opacity="0.30"
      rounded="sm"
      variant="light"
    >
      <b-row class="mb-2">
        <b-col>
          <div class="d-flex align-items-center justify-content-lg-center">
            <order-status-banner
              class="status-bar"
              style="width:100%; font-size: 16px"
              :status-key="order.order_current_status.key"
            />
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-2 mb-2">
        <b-col
          cols="12"
          lg="4"
          class="mobile-column"
        >
          <b-badge
            :variant="'light-' + order.order_current_status.color"
            class="col-container d-flex justify-content-between align-items-center align-items-lg-start flex-wrap position-relative"
          >
            <div class="flex-column flex-lg-row mb-3 mt-1 mb-lg-0 text-lg-left text-container">
              <div
                class="ml-lg-1 mr-lg-1"
                style="margin-top: 4px;"
              >
                <div class="font-weight-bolder mb-1 sub-title">
                  {{ order.waybill_number }}
                </div>
                <h5
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  Service Type: &nbsp;{{ appliedServiceTypeLabel }}
                </h5>
                <h5
                  v-if="hasDeliveryCharge"
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  Delivery Charge: &nbsp;{{ currency_type }} {{ __numberWithCommas(order.delivery_charge) }}
                </h5>
                <h5
                  v-if="appliedRateCardName"
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  Rate Card: &nbsp;{{ appliedRateCardName }}
                </h5>
                <h5
                  v-if="order.shipment_id"
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  Shipment Number: &nbsp; {{ order.shipment_id }}
                </h5>
                <h5
                  v-if="order.nool_shipment_code"
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  Nool Shipment Code: &nbsp; {{ order.nool_shipment_code }}
                </h5>
                <h5
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  COD: &nbsp;{{ currency_type }} {{ __numberWithCommas(order.cod) }}
                </h5>
                <h5
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  Weight: &nbsp;{{ order.weight }}kg
                </h5>
                <h5 class="font-weight-bold font-small-4 ">
                  Created on: &nbsp;{{ __dateTimeFormatter(order.created_at) }}
                </h5>
                <h5
                  class="font-weight-bold font-small-4"
                  style="margin-top:9px"
                >
                  {{ order.description ? ( order.description.length > 190 ? order.description.substring(0,190) + '---' : order.description ) : 'No description' }}
                </h5>
              </div>
            </div>
            <div class="avatar-container">
              <b-avatar
                :text="'C'"
                size="26"
                :variant="myVariant"
              />
            </div>
          </b-badge>
        </b-col>
        <b-col
          cols="12"
          lg="4"
          class="mobile-column"
        >
          <b-badge
            :variant="'light-' + order.order_current_status.color"
            class="col-container"
          >
            <div class="flex-column flex-lg-row mb-3 mt-1 mb-lg-0 text-lg-left">
              <div
                class="ml-lg-1 mr-lg-1 text-container"
                style="margin-top: 4px;"
              >
                <div class="font-weight-bolder mb-1 sub-title">
                  Merchant Details
                </div>
                <h5
                  class="font-weight-bolder"
                  style="margin-bottom:3px;"
                >
                  {{ order.merchant_business.business_name }}
                </h5>
                <h5
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  {{ order.merchant.name }}
                </h5>
                <h5
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  {{ order.merchant.ref_no }}
                </h5>
                <h5
                  class="font-weight-bold font-small-4 opacity-0-per d-none d-lg-flex"
                  style="margin-bottom:3px;"
                >
                  {{ order.merchant.ref_no }}
                </h5>
                <h5 class="font-weight-bold font-small-4">
                  Pickup Address: &nbsp;<b>{{ order.merchant_business.pickup_address }}</b>
                </h5>
                <h5 class="font-weight-bold font-small-4">
                  Merchant Location:
                </h5>
                <div class="mt-1 mb-2">
                  <div
                    class="location-display-trigger"
                    :class="{ 'disabled': !merchantLocation || !merchantLocation.address }"
                    role="button"
                    :tabindex="merchantLocation && merchantLocation.address ? 0 : -1"
                    @click="openMerchantLocationModal"
                    @keyup.enter="openMerchantLocationModal"
                  >
                    <span
                      v-if="merchantLocation && merchantLocation.address"
                      class="flex-text"
                    >{{ merchantLocation.address }}</span>
                    <span
                      v-else
                      class="text-muted"
                    >No location available</span>
                  </div>
                </div>
                <h5
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  Origin City: &nbsp;<b>{{ order.origin_city.name }}</b>
                </h5>
                <h5 class="font-weight-bold font-small-4">
                  Origin Warehouse: &nbsp;<b>{{ order.origin_warehouse.name }}</b>
                </h5>
              </div>
            </div>
          </b-badge>
        </b-col>
        <b-col
          cols="12"
          lg="4"
          class="mobile-column"
        >
          <b-badge
            :variant="'light-' + order.order_current_status.color"
            class="col-container"
          >
            <div class="flex-column flex-lg-row mb-3 mt-1 mb-lg-0 text-lg-left">
              <div
                class="ml-lg-1 mr-lg-1 text-container"
                style="margin-top: 4px;"
              >
                <div class="font-weight-bolder mb-1 sub-title">
                  Customer Details
                </div>
                <h5
                  class="font-weight-bolder"
                  style="margin-bottom:3px;"
                >
                  {{ getCustomerFieldValue('customer_name') }}
                </h5>
                <h5
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  {{ getCustomerFieldValue('customer_address') }}
                </h5>
                <h5
                  v-if="getCustomerFieldValue('customer_email')"
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  {{ getCustomerFieldValue('customer_email') }}
                </h5>
                <h5
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  {{ getCustomerFieldValue('customer_phone') }}
                </h5>
                <h5
                  v-if="shouldShowSecondaryPhone"
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  {{ getCustomerFieldValue('customer_secondary_phone') }}
                </h5>
                <h5 class="font-weight-bold font-small-4">
                  Customer Location:
                </h5>
                <div class="mt-1 mb-2">
                  <div
                    class="location-display-trigger"
                    :class="{ 'disabled': !customerLocation || !customerLocation.address }"
                    role="button"
                    :tabindex="customerLocation && customerLocation.address ? 0 : -1"
                    @click="openCustomerLocationModal"
                    @keyup.enter="openCustomerLocationModal"
                  >
                    <span
                      v-if="customerLocation && customerLocation.address"
                      class="flex-text"
                    >{{ customerLocation.address }}</span>
                    <span
                      v-else
                      class="text-muted"
                    >No location available</span>
                  </div>
                </div>
                <h5
                  class="font-weight-bold font-small-4 mt-1"
                  style="margin-bottom:3px;"
                >
                  Destination City: &nbsp;<b>{{ order.destination_city.name }}</b>
                </h5>
                <h5 class="font-weight-bold font-small-4">
                  Destination Warehouse: &nbsp;<b>{{ order.destination_warehouse.name }}</b>
                </h5>
              </div>
            </div>
          </b-badge>
        </b-col>
      </b-row>
      <b-row class="mx-2 mt-2 mb-2">
        <b-col class="d-flex justify-content-lg-end ml-1 ml-lg-0">
          <div
            v-for="flag_type in order.order_flags"
            :key="flag_type.id"
          >
            <b-badge :variant="getFlagBadgeColor((flag_type.order_flag && flag_type.order_flag.type) || flag_type.type || null)">
              {{ (flag_type.order_flag && flag_type.order_flag.name) || flag_type.name || 'Unknown Flag' }}
            </b-badge>
          </div>
        </b-col>
      </b-row>

      <b-tabs
        content-class="pt-1 min-height-59vh"
        fill
      >
        <b-tab
          title="Order History"
          class="p-2"
        >
          <app-timeline>
            <app-timeline-item
              v-for="(data, index) in timelineData"
              :key="index"
              :variant="order.order_setting.is_pickup_enable && data.status.key === 'key_2' ? 'success' : `${data.status.color || 'primary'}`"
              :icon="data.status.icon"
            >
              <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
                <b-badge
                  :variant="data.status.color ? data.status.color : 'primary'"
                  class="mb-2 mobile-column"
                >
                  <div class="text-center">
                    <h6 class="mb-0 text-sm text-wrap">
                      {{ data.status.name }}
                    </h6>
                  </div>
                </b-badge>
                <small class="date-container">{{ __dateTimeFormatter(data.date_time) }}  {{ data.date_time_ago }}</small>
              </div>
              <p>{{ data.reason || '' }}</p>
              <div v-if="(index=='0' && order.rider_signature != '')">
                <b-button
                  v-if="order.order_current_status.key == 'key_7' || order.order_current_status.key == 'key_13' || order.order_current_status.key == 'key_14'"
                  variant="outline-primary"
                  size="sm"
                  class="btn m-1 mr-1 btn-outline-primary btn-sm"
                  @click="openSignatureModal()"
                >
                  View Signature
                </b-button>
              </div>
              <div v-if="(shouldShowProofBtn(data))">
                <b-button
                  variant="outline-primary"
                  size="sm"
                  class="btn m-1 mr-1 btn-outline-primary btn-sm"
                  @click="openProofDocModal(data.proofs)"
                >
                  View Proof Images
                </b-button>
              </div>
              <div v-if="hasOrderCurrentLocation(data)">
                <b-button
                  variant="outline-primary"
                  size="sm"
                  class="btn m-1 mr-1 btn-outline-primary btn-sm"
                  @click="openTimelineLocationModal(data)"
                >
                  View Location
                </b-button>
              </div>
              <div class="d-flex flex-sm-row flex-column justify-content-between align-items-start">
                <b-media>
                  <template #aside>
                    <b-avatar
                      :src="`https://picsum.photos/200/200?random=${index}`"
                      class="mr-30"
                      variant="light-success"
                    />
                  </template>
                  <h5>{{ data.user.first_name || '' }} {{ data.user.last_name || '' }}</h5>
                  <h6>{{ data.user.reference_id || '' }}</h6>
                  <span>{{ data.user_role || '' }}</span>
                </b-media>
              </div>
            </app-timeline-item>
          </app-timeline>
        </b-tab>
        <b-tab
          title="Invoice History"
          class="px-2"
          @click="getOrderInvoiceTimeline()"
        >
          <app-timeline v-if="invoiceTimelineData.length>0">
            <div
              class="shadow rounded-sm mb-3 w-100 bg-light-secondary"
              style="padding:10px;"
            >
              <div class="font-small-5 font-weight-bold text-center text-dark">
                Invoice No : {{ invoiceTimelineData[0].invoice_no }}
              </div>
            </div>
            <app-timeline-item
              v-for="(data, index) in invoiceTimelineData"
              :key="index"
              :variant="'light-'+data.status.color ? data.status.color : 'primary'"
              :icon="data.status.icon"
            >
              <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
                <div>
                  <h6>{{ data.status.name }}</h6>
                  <h5 class="font-small-3">
                    {{ data.invoice_amount }}
                  </h5>
                </div>
                <small class="text-muted">{{ __dateTimeFormatter(data.date_time) }} | {{ data.date_time_ago }}</small>
              </div>
              <p>{{ data.reason || '' }}</p>
              <div class="d-flex flex-sm-row flex-column justify-content-between align-items-start">
                <b-media>
                  <template #aside>
                    <b-avatar
                      :src="`https://picsum.photos/200/200?random=${index}`"
                      class="mr-30"
                      variant="light-success"
                    />
                  </template>
                  <h6>{{ data.user.first_name || '' }} {{ data.user.last_name || '' }}</h6>
                  <h6>{{ data.user.reference_id || '' }}</h6>
                  <span class="text-muted">{{ data.user_role || '' }}</span>
                </b-media>
              </div>
            </app-timeline-item>
          </app-timeline>
          <div
            v-else
            class="d-flex justify-content-center align-items-center"
          >
            This order has no recorded Invoice history
          </div>
        </b-tab>
        <b-tab
          :title="`General Remarks (${remarksCount})`"
          @click="getOrderRemarkTimeLine()"
        >
          <div v-if="order.remark && order.remark.length">
            <remark-table
              :remarks="order.remark"
              :order-id="id"
            />
          </div>
          <div
            v-else
            class="d-flex justify-content-center align-items-center"
          >
            This order has no remarks
          </div>
        </b-tab>
        <b-tab
          v-if="order.order_flags && order.order_flags.length > 0"
          title="Flag History"
          @click="getOrderFlagTimeLine()"
        >
          <flag-details
            :flag_data="flagTimelineData"
          />
        </b-tab>
        <b-tab
          title="Edit Log History"
          @click="getOrderEditLogTimeline()"
        >
          <div>
            <order-edit-logs
              :edit_log_data="editLogTimelineData"
            />
          </div>
        </b-tab>
      </b-tabs>

    </b-overlay>
    <b-modal
      id="signature-view"
      v-model="signatureOpen"
      size="sm"
      centered
      hide-footer
      title="VIEW SIGNATURE"
    >
      <div class="signature-container">

        <img
          :src="`${cdn}${order.rider_signature}`"
          alt="Rider's Signature"
          class="signature"
        >
        <!-- <b-button
          class="btn m-1 btn-outline-primary btn-sm"
          variant="outline-primary"
          size="sm"
          @click="downloadImg(`${cdn}${order.rider_signature}`, `${order.waybill_number}`)"
        >Download</b-button> -->
      </div>
    </b-modal>
    <b-modal
      id="proof-doc-open-view"
      v-model="proofDocOpen"
      size="lg"
      centered
      hide-footer
      title="VIEW PROOF IMAGES"
    >
      <div>
        <b-row>
          <b-col
            v-for="(p, i) in selectedProofs"
            :key="p.id || i"
            cols="6"
            class="mb-2"
          >
            <img
              :src="p.url"
              alt="Proof"
              class="proof-image"
            >
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <!-- Location View Modals -->
    <base-location-view-modal
      :modal-id="`customer-location-view-modal-${id}`"
      modal-title="Customer Location"
      :location-data="customerLocation"
      :google-api-key="googleMapsKey"
    />

    <base-location-view-modal
      :modal-id="`merchant-location-view-modal-${id}`"
      modal-title="Merchant Location"
      :location-data="merchantLocation"
      :google-api-key="googleMapsKey"
    />

    <base-location-view-modal
      :modal-id="`timeline-location-view-modal-${id}`"
      modal-title="Order Current Location"
      :location-data="timelineLocation"
      :google-api-key="googleMapsKey"
    />
  </b-modal>
</template>

<script>
import {
  BModal,
  BOverlay,
  VBModal,
  BTabs,
  BTab,
  BAvatar,
  BRow,
  BCol,
  BBadge,
  BMedia,
  BButton,
} from 'bootstrap-vue'
import OrderStatusBanner from '@core/components/status/OrderStatusBanner.vue'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import displayAmountWithCurrency from '@core/mixins/currency'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import emptyOrderPayload from '@/models/order'
import { avatarText } from '@core/utils/filter'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import RemarkTable from '@/components/orders/remarks/RemarkTable.vue'
import FlagDetails from '@/components/orders/FlagHistoryDetails.vue'
import OrderEditLogs from '@/components/orders/OrderEditLogs.vue'
import BaseLocationViewModal from '@/components/BaseLocationViewModal.vue'
import { appliedServiceTypeLabel as formatAppliedServiceType } from '@/helpers/serviceTypeFeature'

const OrderRepository = RepositoryFactory.get('order')

export default {
  name: 'ViewOrderModal',
  directives: {
    'b-modal': VBModal,
  },
  components: {
    BModal,
    BOverlay,
    BTabs,
    BTab,
    BAvatar,
    BRow,
    BCol,
    BBadge,
    BMedia,
    BButton,
    OrderStatusBanner,
    AppTimeline,
    AppTimelineItem,
    RemarkTable,
    FlagDetails,
    OrderEditLogs,
    BaseLocationViewModal,
  },
  mixins: [SuccessMessage, ErrorMessage, displayAmountWithCurrency],
  data() {
    return {
      avatarText,
      open: false,
      signatureOpen: false,
      modalLoading: false,
      id: null,
      timelineData: [],
      invoiceTimelineData: [],
      remarksCount: 0,
      loadingRemarks: false,
      flagTimelineData: [],
      order: emptyOrderPayload(),
      fields: [
        { key: 'remarkedBy', label: 'Remarked By', sortable: true },
        { key: 'remark', label: 'Remark', sortable: false },
        { key: 'created_at', label: 'Remark Date', sortable: false },
      ],
      cdn: process.env.VUE_APP_BUCKET_URL,
      myVariant: '',
      proofDocOpen: false,
      selectedProofs: [],
      editLogTimelineData: [],
      customerLocation: null,
      merchantLocation: null,
      timelineLocation: null,
      googleMapsKey: '',
    }
  },
  computed: {
    shouldShowSecondaryPhone() {
      // Check if secondary phone exists (works for both encrypted and non-encrypted)
      // The masking is handled by getCustomerFieldValue(), so we just need to check if field exists
      return this.order.customer_secondary_phone !== null && this.order.customer_secondary_phone !== undefined && this.order.customer_secondary_phone !== ''
    },
    appliedServiceTypeLabel() {
      return formatAppliedServiceType(this.order && this.order.applied_service_type)
    },
    hasDeliveryCharge() {
      return this.order && this.order.delivery_charge !== null && this.order.delivery_charge !== undefined && this.order.delivery_charge !== ''
    },
    appliedRateCardName() {
      return this.order && this.order.applied_rate_card && this.order.applied_rate_card.card_name
        ? this.order.applied_rate_card.card_name
        : ''
    },
  },
  methods: {
    getCustomerFieldValue(fieldName, defaultValue = null) {
      // If order is encrypted
      if (this.order.is_encrypted) {
        // If user has permission, API returns decrypted data - show it
        if (this.$can('show-decrypted-orders')) {
          return this.order[fieldName] || defaultValue || ''
        }
        // Otherwise show masked
        return '******'
      }
      // If not encrypted, show original value
      return this.order[fieldName] || defaultValue || ''
    },
    async openModal(id) {
      this.open = true
      this.id = id
      // Initialize Google Maps API key
      this.googleMapsKey = this.$route?.query?.gmaps_key || process.env.VUE_APP_GOOGLE_MAPS_API_KEY || this.googleMapsKey
      this.remarksCount = 0
      this.flagTimelineData = []
      await this.fetchOrderDetails()
      await this.getOrderTimeline()
    },
    async getOrderTimeline() {
      try {
        this.loading = true
        const { data } = await OrderRepository.getOrderTimeLine(this.id)
        this.timelineData = (data.data || []).map(item => ({
          ...item,
          proofs: Array.isArray(item.proofs) ? item.proofs : [],
        }))
        this.loading = false
      } catch (e) {
        this.timelineData = []
        this.loading = false
      }
    },
    openSignatureModal() {
      this.signatureOpen = true
    },
    openProofDocModal(proofs) {
      this.selectedProofs = proofs
      this.proofDocOpen = true
    },
    async getOrderInvoiceTimeline() {
      try {
        this.loading = true
        const { data } = await OrderRepository.getOrderInvoiceTimeLine(this.id)
        this.invoiceTimelineData = data.data
        if (this.invoiceTimelineData.length > 0) {
          const pendingCopy = JSON.parse(JSON.stringify(data.data.slice().pop()))
          pendingCopy.status.name = 'Created'
          pendingCopy.status.color = 'success'
          this.invoiceTimelineData.push(pendingCopy)
        }
        this.loading = false
      } catch (e) {
        this.invoiceTimelineData = []
        this.loading = false
      }
    },
    getCustomerLocationFieldValue(fieldName, defaultValue = null) {
      if (!this.order.customer_location) {
        return defaultValue || ''
      }

      const rawValue = this.order.customer_location[fieldName]

      // If order is encrypted
      if (this.order.is_encrypted) {
        // If user has permission, API returns decrypted data - show it
        if (this.$can('show-decrypted-orders')) {
          return rawValue || defaultValue || ''
        }
        // Otherwise show masked
        return '******'
      }
      // If not encrypted, show original value
      return rawValue || defaultValue || ''
    },
    async fetchOrderDetails() {
      try {
        this.modalLoading = true
        const { data } = (await OrderRepository.fetchOrderDetailsById(this.id)).data
        this.order = data
        this.myVariant = this.order.order_current_status.color
        this.remarksCount = data.remark || 0
        this.$set(this.order, 'remark', [])

        // Format customer location data - apply encryption masking
        this.customerLocation = null
        if (this.order.customer_location) {
          // Determine if we should mask location data
          const shouldMask = this.order.is_encrypted && !this.$can('show-decrypted-orders')

          // Get address value (masked or decrypted based on permission)
          const addressValue = this.getCustomerLocationFieldValue('address', '')

          // For latitude/longitude, mask if encrypted and user doesn't have permission
          let latitude = null
          let longitude = null
          if (!shouldMask) {
            latitude = this.order.customer_location.latitude || null
            longitude = this.order.customer_location.longitude || null
          }

          this.customerLocation = {
            address: addressValue,
            latitude,
            longitude,
            source: this.getCustomerLocationFieldValue('source', 'api'),
          }
        }

        // Format merchant location data - always initialize
        this.merchantLocation = null
        if (this.order.default_business_address && this.order.default_business_address.merchant_location) {
          this.merchantLocation = {
            address: this.order.default_business_address.merchant_location || '',
            latitude: null,
            longitude: null,
            source: 'merchant',
          }
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.modalLoading = false
    },
    async getOrderRemarkTimeLine() {
      this.loadingRemarks = true
      try {
        const { data } = await OrderRepository.getOrderRemarkTimeLine(this.id)
        this.$set(this.order, 'remark', data.remark)
      } catch (e) {
        this.order.remark = []
      } finally {
        this.loadingRemarks = false
      }
    },
    async getOrderFlagTimeLine() {
      try {
        const { data } = await OrderRepository.getOrderFlagTimeLine(this.id)
        this.flagTimelineData = data.order_flags
      } catch (e) {
        this.flagTimelineData = []
      }
    },
    getFlagBadgeColor(type) {
      if (type === 'flag_1') {
        return 'light-info'
      }
      if (type === 'flag_2') {
        return 'light-danger'
      }
      if (type === 'flag_3') {
        return 'light-primary'
      }
      if (type === 'flag_4') {
        return 'light-dark'
      }
      if (type === 'flag_5') {
        return 'light-success'
      }
      if (type === 'flag_6') {
        return 'light-warning'
      }
      if (type === 'flag_7') {
        return 'light-danger'
      }
      if (type === 'flag_8') {
        return 'light-info'
      }
      return 'light-primary'
    },
    downloadImg(urlFromFunction, wayBillNumber) {
      const xhr = new XMLHttpRequest()
      const fileName = `${wayBillNumber}_customer_signature.png`
      const dataType = 'png'
      xhr.onload = function c() {
        const arr = new Uint8Array(this.response)
        const raw = String.fromCharCode.apply(null, arr)
        const b64 = btoa(raw)
        const dataURL = `data:image/${dataType};base64,${b64}`
        const element = document.createElement('a')
        element.href = dataURL
        element.setAttribute('download', fileName)
        document.body.appendChild(element)
        element.click()
        element.remove()
      }
      xhr.open('GET', urlFromFunction)
      xhr.responseType = 'arraybuffer'
      xhr.send()
    },
    shouldShowProofBtn(data) {
      const allowed = ['key_6', 'key_7', 'key_13', 'key_14', 'key_15', 'key_16']
      return Array.isArray(data.proofs) && data.proofs.length > 0 && allowed.includes(data.status?.key)
    },
    hasOrderCurrentLocation(data) {
      if (!data || typeof data.order_current_location !== 'string') {
        return false
      }
      const location = data.order_current_location.trim()
      if (!location) {
        return false
      }
      const [lat, lng] = location.split(',').map(value => Number(value.trim()))
      return Number.isFinite(lat) && Number.isFinite(lng)
    },
    openTimelineLocationModal(data) {
      if (!this.hasOrderCurrentLocation(data)) {
        return
      }
      const [lat, lng] = data.order_current_location.split(',').map(value => Number(value.trim()))
      this.timelineLocation = {
        address: `Coordinates: ${lat}, ${lng}`,
        latitude: lat,
        longitude: lng,
        source: 'timeline',
      }
      this.$bvModal.show(`timeline-location-view-modal-${this.id}`)
    },
    async getOrderEditLogTimeline() {
      try {
        const response = await OrderRepository.getOrderEditLogTimeline(this.id)
        const { data } = response
        if (data.success && data.data) {
          this.editLogTimelineData = data.data
        } else {
          this.editLogTimelineData = []
        }
      } catch (e) {
        this.editLogTimelineData = []
      }
    },
    openCustomerLocationModal() {
      if (this.customerLocation && this.customerLocation.address) {
        this.$bvModal.show(`customer-location-view-modal-${this.id}`)
      }
    },
    openMerchantLocationModal() {
      if (this.merchantLocation && this.merchantLocation.address) {
        this.$bvModal.show(`merchant-location-view-modal-${this.id}`)
      }
    },
  },
}
</script>

<style scoped >
  .signature-container {
    display: flex;
    justify-content:center;
    align-items:center;
    flex-direction: column;
  }
  h5 {
    color: #000000;
  }
  .order-status-name {
    color: white;
  }
  .text-container {
    max-width: 100%; /* Set your desired maximum width */
    word-wrap: break-word; /* Break long words to the next line */
    white-space: normal; /* Allow whitespace to wrap */
  }
  .date-container {
    max-width: 100px; /* Set your desired maximum width */
    word-wrap: break-word; /* Break long words to the next line */
    white-space: normal; /* Allow whitespace to wrap */
    text-align: right;
    margin-top: 7px;
    font-weight: 500;
  }
  .col-container {
    width: 100%;
    min-height: 100%;
  }
  .sub-title{
    font-size:large;
  }
  p {
    font-weight: bold;
  }
  .status-bar {
  padding: 1rem;
}
.col-container {
  position: relative;
}

.avatar-container {
  position: absolute;
  top: 0;
  right: 0;
  margin: 10px;
}
@media (max-width: 1200px) {
  .avatar-container {
    position: static;
    margin: 0;
  }
}
@media (max-width: 767px) {
  .status-bar {
    padding: 0.5rem;
  }
  .col-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  #modal-order-view {
      max-width: 100%;
      width: 100%;
    }
    .view-sign-button {
    display: block;
  }
  .date-container {
    text-align: left;
  }
  .mobile-column {
    width: 100% !important;
    margin-bottom: 1rem;
  }
  .avatar-container {
    justify-content: center;
    width: 100%;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .status-bar {
    padding: 0.5rem;
  }
  .col-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  #modal-order-view {
      max-width: 100%;
      width: 100%;
    }
    .view-sign-button {
    display: block;
  }
  .date-container {
    text-align: left;
  }
  .mobile-column {
    width: 100% !important;
    margin-bottom: 1rem;
  }
  .avatar-container {
    justify-content: center;
    width: 100%;
  }
}
.proof-image {
  width: 100%;
  max-height: 200px;
  object-fit: contain;
  border-radius: 4px;
  border: 1px solid #e9ecef;
  cursor: pointer;
  transition: transform 0.2s ease;
  background-color: #f8f9fa;
}

.proof-image:hover {
  transform: scale(1.02);
}

.location-display-trigger {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.375rem 0.75rem;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  cursor: pointer;
  min-height: calc(1.9em + 0.75rem + 2px);
  font-size: 0.875rem;
  line-height: 1.5;
  color: #495057;
  transition: all 0.15s ease-in-out;
}

.location-display-trigger:hover {
  background: #e9ecef;
  border-color: #adb5bd;
}

.location-display-trigger:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.location-display-trigger.disabled {
  cursor: not-allowed;
  opacity: 0.6;
  background: #f8f9fa;
}

.location-display-trigger.disabled:hover {
  background: #f8f9fa;
  border-color: #dee2e6;
}

.flex-text {
  flex: 1 1 auto;
}
</style>
